import dashboardReducer from './reducers/dashboard';
import lockdropReducer from './reducers/lockdrop';

const rootReducer = {
  dashboard: dashboardReducer,
  lockdrop: lockdropReducer,
};

export default rootReducer;
